import React from 'react';
import PromotionsPage from '../../components/Sales/PromotionsPage/PromotionsPage';
import { connect } from 'react-redux';

const PromotionsPageContainer = (props) => (
  <PromotionsPage {...props} />
);

const mapState = state => {
  return {
    selectedCompany: state.header.selectedCompany,
    test: 1,
  }
}

export default connect(mapState, {})(PromotionsPageContainer);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/PromotionsPage.jsx